import gql from 'graphql-tag';

/**
 * 上传文件
 */
export const fetchUploadBystreamDocument = gql`
  mutation uploadBystream($input: FileInput!) {
    uploadBystream(input: $input)
  }
`;
